import { CheckboxForm } from "../CheckboxForm/CheckboxForm"

export const CustomCheckbox = (
  {
    label = ``,
    inputClassName = ``,
    labelClassName = ``,
    isLabelLeftAligned = false,
    normalText = false,
    isChecked = false,
    onChange = () => {},
    style = {},
    labelStyle = {},
    isDisabled = false,
    analytics_key = ``,
    shouldNotTrackInComponent = false,
    testid = "CustomCheckbox",
    isUncontrolled = false,
    showTabIndex = true,
    ariaLabel = ``,
    ariaDescribedBy = ``,
    ariaReadonly = false,
    customerId = ``,
  },
  ...props
) => (
  <div data-testid={testid}>
    <CheckboxForm
      {...props}
      isUncontrolled={isUncontrolled}
      analytics_key={analytics_key}
      shouldNotTrackInComponent={shouldNotTrackInComponent}
      inputClassName={`CustomCheckbox ${inputClassName}`}
      inputStyle={style}
      labelPlacement={isLabelLeftAligned ? `start` : `end`}
      labelClassName={`${normalText ? `` : `wm-link`} ${labelClassName}`}
      itemStyle={{
        ...labelStyle,
        cursor: `pointer`,
        position: `relative`,
        top: normalText ? 0 : `.3rem`,
      }}
      items={[
        {
          label,
          checked: isChecked,
          onChange,
          disabled: isDisabled,
        },
      ]}
      showTabIndex={showTabIndex}
      ariaLabel={ariaLabel}
      ariaReadonly={ariaReadonly}
      ariaDescribedBy={ariaDescribedBy}
      customerId={customerId}
    />
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// CustomCheckbox.propTypes = {
//   checkboxClassName: PropTypes.string,
//   label: PropTypes.string,
//   inputClassName: PropTypes.string,
//   labelClassName: PropTypes.string,
//   isChecked: PropTypes.bool,
//   isDisabled: PropTypes.bool,
//   isLabelLeftAligned: PropTypes.bool,
//   onChange: PropTypes.func,
//   style: PropTypes.object,
//   checkboxStyle: PropTypes.object,
//   normalText: PropTypes.bool,
//   analytics_key: PropTypes.string,
//   shouldNotTrackInComponent: PropTypes.bool,
//   labelStyle: PropTypes.object,
//   testid: PropTypes.string,
//   isUncontrolled: PropTypes.bool,
//   showTabIndex: PropTypes.bool,
//   ariaLabel: PropTypes.string,
//   ariaReadonly: PropTypes.bool,
//   ariaDescribedBy: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// CustomCheckbox.defaultProps = {
//   checkboxClassName: ``,
//   label: ``,
//   inputClassName: ``,
//   labelClassName: ``,
//   isChecked: false,
//   isDisabled: false,
//   isLabelLeftAligned: false,
//   onChange: () => {},
//   style: {},
//   labelStyle: {},
//   checkboxStyle: {},
//   normalText: false,
//   analytics_key: ``,
//   shouldNotTrackInComponent: false,
//   testid: "CustomCheckbox",
//   isUncontrolled: false,
//   showTabIndex: true,
//   ariaLabel: ``,
//   ariaReadonly: false,
//   ariaDescribedBy: ``,
// }

export default CustomCheckbox
